export default __webpack_public_path__ + "static/media/img_step_hami08.8dfb9f11.png";